// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import { i18next } from "@translations/invenio_app_rdm/i18next";
import React from "react";
import {
  PublishModal,
  SubmitReviewModal,
} from "@js/invenio_rdm_records";
import { parametrize } from "react-overridable";
import PropTypes from "prop-types";
import { SafeCreatibutorsField } from "./SafeCreatibutorsField";

const AuthorsField = ({ config }) => {
  const vocabularies = {
    metadata: {
      ...config.vocabularies,
      creators: {
        ...config.vocabularies.creators,
        type: [
          { text: "Person", value: "personal" },
          { text: "Organization", value: "organizational" },
        ],
      },
      contributors: {
        ...config.vocabularies.contributors,
        type: [
          { text: "Person", value: "personal" },
          { text: "Organization", value: "organizational" },
        ],
      },
      identifiers: {
        ...config.vocabularies.identifiers,
      },
    },
  };

  return (
    <SafeCreatibutorsField
      addButtonLabel={i18next.t("Add author")}
      label={i18next.t("Authors")}
      labelIcon="user"
      fieldPath="metadata.creators"
      roleOptions={vocabularies.metadata.creators.role}
      schema="creators"
      autocompleteNames={config.autocomplete_names}
      required
      modal={{
        addLabel: i18next.t("Add author"),
        editLabel: i18next.t("Edit author"),
      }}
    />
  );
};

AuthorsField.propTypes = {
  config: PropTypes.shape({
    vocabularies: PropTypes.object.isRequired,
    autocomplete_names: PropTypes.bool.isRequired,
  }).isRequired,
};

const complianceParameters = {
  extraCheckboxes: [
    {
      fieldPath: "acceptBaobabCompliance",
      text: i18next.t(
        "I confirm that this record complies with BAOBAB repository policies."
      ),
    },
  ],
};

const PublishModalComponent = parametrize(PublishModal, complianceParameters);
const SubmitReviewModalComponent = parametrize(
  SubmitReviewModal,
  complianceParameters
);

export default AuthorsField;

export const overriddenComponents = {
  "InvenioAppRdm.Deposit.CreatorsField.container": AuthorsField,
  "InvenioRdmRecords.PublishModal.container": PublishModalComponent,
  "InvenioRdmRecords.SubmitReviewModal.container": SubmitReviewModalComponent,
};
